/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, August 2022
 * @format
 * @flow
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Group, Rect, Transformer, Text as KonvaText } from 'react-konva';
import tranformerConfig from './tranformerConfig';

//Table description:- Table_10_Rect_1_4_1_4_90Deg
//Table_<seat capacity>_<table type>_<seat arrangement>_<angle>Deg
const Table_10_Rect_1_4_1_4_90Deg = props => {
  const {
    shapeProps,
    isSelected,
    onSelect,
    onChange,
    draggable,
    tableInfoColumn,
    keyName1,
    keyName2,
    keyName3,
  } = props;
  const { x, y, scaleX, scaleY, rotation, stroke, strokeWidth } = shapeProps;
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Group
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        scaleX={scaleX}
        scaleY={scaleY}
        rotation={rotation}
        draggable={draggable}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      >
        <Rect x={0} y={30} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={20} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={70} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={120} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={170} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={20} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={70} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={120} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={170} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={220} y={30} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={10} y={10} stroke={stroke} strokeWidth={strokeWidth} width={210} height={80} />
        {tableInfoColumn && <KonvaText text={shapeProps[tableInfoColumn]} x={90} y={40} fill={stroke} fontSize={25} />}
        {keyName1 && <KonvaText text={shapeProps[keyName1]} x={90} y={20} fill={'white'} fontSize={14} />}
        {keyName2 && <KonvaText text={shapeProps[keyName2]} x={90} y={70} fill={'white'} fontSize={14} />}
        {keyName3 && <KonvaText text={shapeProps[keyName3]} x={190} y={40} fill={'white'} fontSize={14} />}
      </Group>
      {draggable && isSelected && <Transformer ref={trRef} {...tranformerConfig} />}
    </>
  );
};

export default Table_10_Rect_1_4_1_4_90Deg;

Table_10_Rect_1_4_1_4_90Deg.propTypes = {
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
  tableInfoColumn: PropTypes.string,
};

Table_10_Rect_1_4_1_4_90Deg.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
